import styled, { css } from "styled-components";

import { ComponentErrorBoundaryContainer } from "shared/components/atoms/ComponentErrorBoundary/styles";

export const FallbackBackground = styled.div`
  background-color: #393939;
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  color: white !important;
  text-align: center;
`;

interface IBillboardBannerWithLinkContainerProps {
  hasLink: boolean;
}

export const BillboardBannerWithLinkContainer = styled.div<IBillboardBannerWithLinkContainerProps>`
  &,
  ${FallbackBackground} {
    max-height: 85vh;
  }

  a {
    aspect-ratio: 16/9;
    display: block;
    width: 100%;
    height: 100%;

    ${({ hasLink }) =>
      !hasLink &&
      css`
        cursor: default;
      `}
  }

  position: relative;

  img {
    object-fit: cover;
  }

  .background-linear-gradient {
    height: 100%;
    width: 100%;
    left: 0;
    position: absolute;
    transition: opacity 500ms ease-in-out;
    top: 0;

    pointer-events: none;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
  }

  > .background-linear-gradient {
    width: 100%;
  }

  ${ComponentErrorBoundaryContainer} {
    height: 100%;
    justify-content: center;
    z-index: 1;
    position: relative;
  }
`;
